import './App.scss';
import Header from '../Tools/Header/Header';
import Footer from '../Tools/Footer/Footer';
import Menu from '../Tools/Menu/Menu';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Offline, Online } from "react-detect-offline";
import Main from './Main';

// blogs images
import unlock from '../Images/unlock.png'
import reload from '../Images/reload.png'
import Chimney1 from '../Images/Chimney1.jpeg'
import Chimney2 from '../Images/Chimney2.jpeg'
import Chimney3 from '../Images/Chimney3.jpeg'
import Chimney4 from '../Images/Chimney4.jpeg'
import callbtn from '../Images/telephone.png'
import PopUp from '../Tools/PopUp/PopUp';

function App() {
  const [showMenu, setShowMenu] = useState(false)
  const [showPopUp, setShowPopUp] = useState(false)
  const [showVerify, setShowVerify] = useState(true)
  const [status, setStatus] = useState(true);
  const navigate = useNavigate()
  const location = useLocation()

  const url = new URL(window.location.href);
  const [CitiesData, setCitiesData] = useState({});
  const [CitiePhone, setCitiePhone] = useState(url.searchParams.get('cp') ? url.searchParams.get('cp') : "866-907-7220");
  useEffect(() => {
    (async () => {

      // google //
      if (url.searchParams.get('spg') == "g") {
        const CitiesZipGoogle2 = (await import('./CitiesZipGoogle2.js')).default;
        if (CitiesZipGoogle2.find(a => a.ID == url.searchParams.get('cd'))) {
          const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${CitiesZipGoogle2.find(a => a.ID == url.searchParams.get('cd')).ZC}&key=AIzaSyC_XBMupYyuYy-f1TGdo32rsoHBhSMWPK0&language=en`, { method: 'GET', })
          const data = await res.json()
          // console.log(data.results[0])
          setCitiesData({
            "ID": CitiesData.ID,
            "City":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),
            "Full":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name + ', ' + data.results[0].address_components.find(a => a.types.find(a => a == 'administrative_area_level_1')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),

          })
        } else {
          const CitiesDataGoogle = (await import('./CitiesDataGoogle.js')).default;
          if (CitiesDataGoogle.find(a => a.ID == url.searchParams.get('cd'))) {
            setCitiesData(CitiesDataGoogle.find(a => a.ID == url.searchParams.get('cd')))
          } else {
            setCitiesData({})
          }
        }
      }

      // Microsoft //
      if (url.searchParams.get('spg') == "m") {
        const CitiesZipMS2 = (await import('./CitiesZipMS2.js')).default;
        if (CitiesZipMS2.find(a => a.ID == url.searchParams.get('cd'))) {
          const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${CitiesZipMS2.find(a => a.ID == url.searchParams.get('cd')).ZC}&key=AIzaSyC_XBMupYyuYy-f1TGdo32rsoHBhSMWPK0&language=en`, { method: 'GET', })
          const data = await res.json()
          setCitiesData({
            "ID": CitiesZipMS2.find(a => a.ID == url.searchParams.get('cd')).ID,
            "City":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),
            "Full":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name + ', ' + data.results[0].address_components.find(a => a.types.find(a => a == 'administrative_area_level_1')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),

          })
        } else {
          const CitiesDataMS = (await import('./CitiesDataMS.js')).default;
          if (CitiesDataMS.find(a => a.ID == url.searchParams.get('cd'))) {
            setCitiesData(CitiesDataMS.find(a => a.ID == url.searchParams.get('cd')))
          } else {
            setCitiesData({})
          }
        }
      }



      if (showVerify == true) {
        document.body.style.overflow = "hidden"
        document.body.style.overflow = "scroll"
      } else {
        document.body.style.overflow = "scroll"
      }
      setTimeout(() => {
        const checkpop = localStorage.getItem("showPopUp");
        if (checkpop) {
          setShowPopUp(false)
        } else {
          setShowPopUp(true)
        }
      }, 5000);
      window.addEventListener('online', () => setStatus(true))
      window.addEventListener('offline', () => setStatus(false))
    })();
  }, [showVerify, status]);

  // locationsMain
  const locationsMain = [
    {
      "Location": "Orange County",
      "Phone": "714-515-7063",
      "Address": [
        {
          "Location1": "Orange County",
          "Address1": "559 S Harbor Blvd,Anaheim, CA 92805",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1igOR7boZkzmdyNwUcncKxxA65IggcHE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Riverside",
      "Phone": "951-338-8718",
      "Address": [
        {
          "Location1": "Riverside",
          "Address1": "3579 Arlington Ave,Riverside, CA 92506",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1igOR7boZkzmdyNwUcncKxxA65IggcHE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Los Angeles",
      "Phone": "213-772-3146",
      "Address": [
        {
          "Location1": "Los Angeles",
          "Address1": "1944 W Olympic Blvd, Los Angeles, CA 90006",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1igOR7boZkzmdyNwUcncKxxA65IggcHE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Studio City",
      "Phone": "747-319-5372",
      "Address": [
        {
          "Location1": "Studio City",
          "Address1": "11650 Riverside Dr, Studio City, CA 91602",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1igOR7boZkzmdyNwUcncKxxA65IggcHE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Oxnard",
      "Phone": "805-909-4514",
      "Address": [
        {
          "Location1": "Oxnard",
          "Address1": "2350 Wankel Way, Oxnard, CA 93030",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1igOR7boZkzmdyNwUcncKxxA65IggcHE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Santa Monica",
      "Phone": "424-788-0720",
      "Address": [
        {
          "Location1": "Santa Monica",
          "Address1": "1600 Lincoln Blvd,Santa Monica, CA 90404",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1igOR7boZkzmdyNwUcncKxxA65IggcHE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Santa Clarita",
      "Phone": "661-727-7527",
      "Address": [
        {
          "Location1": "Santa Clarita",
          "Address1": "24801 Pico Canyon Rd, Stevenson Ranch, CA 91381",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1igOR7boZkzmdyNwUcncKxxA65IggcHE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Diego",
      "Phone": "619-975-3437",
      "Address": [
        {
          "Location1": "San Diego",
          "Address1": "3703 Camino Del Rio S,San Diego, CA 92108",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1t041CxbPzWmdnVenmhzZGIwlfxETi7E&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Fransisco",
      "Phone": "415-275-6631",
      "Address": [
        {
          "Location1": "San Fransisco",
          "Address1": "1169 Howard St,San Francisco, CA 94103",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1P2j6c4nBHDRM-AtgEDKq0HXXFq0TcIM&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Jose",
      "Phone": "408-831-3259",
      "Address": [
        {
          "Location1": "San Jose",
          "Address1": "5353 Almaden Expy, San Jose, CA 95118",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1P2j6c4nBHDRM-AtgEDKq0HXXFq0TcIM&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Sacramento",
      "Phone": "916-818-5337",
      "Address": [
        {
          "Location1": "Sacramento",
          "Address1": "455 Watt Ave,Sacramento, CA 95864",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1f4Ra1abEjnnszAfIdOD2KJJTEde07R0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Maryland",
      "Phone": "443-909-2661",
      "Address": [
        {
          "Location1": "Maryland",
          "Address1": "1700 Rockville Pike,Rockville, MD 20852",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1hFBKavqDPHMd0GUtJ-dU5YcIwaZPHZg&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Kansas",
      "Phone": "916-818-5337",
      "Address": [
        {
          "Location1": "Kansas",
          "Address1": "10308 State Line Rd,Leawood, KS 66206",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1cyZUyG54v6vYltik3L6Zbfpd7Cm6gW0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "New Jeresy",
      "Phone": "848-306-0896",
      "Address": [
        {
          "Location1": "New Jeresy",
          "Address1": "1909 Route 70 E, Cherry Hill, NJ 08003",
        },
        {
          "Location1": "New Jeresy",
          "Address1": "163 W Route 37, Toms River, NJ 08755",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1wCzvOW3l5LHsYiJ8weh2xoTKcaS8nb8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Tampa",
      "Phone": "813-303-1051",
      "Address": [
        {
          "Location1": "Tampa",
          "Address1": "2701 W Busch Blvd, Tampa, FL 33618",
        },
        {
          "Location1": "Fort Myers",
          "Address1": "5285 Summerlin Rd, Fort Myers, FL 33919",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1sLBr2KXbf8fs1MWdeT9eGkrQDZ-gqXk&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Orlando",
      "Phone": "407-512-9758",
      "Address": [
        {
          "Location1": "Orlando",
          "Address1": "127 N Magnolia Ave, Orlando, FL 32801",
        },
        {
          "Location1": "Jacksonville",
          "Address1": "3901 Carmichael Ave, Jacksonville, FL 32207",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1NjUXcA6OX2tJZ-Xht56H0wZZNLiGbeQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Nasville",
      "Phone": "629-263-6794",
      "Address": [
        {
          "Location1": "Nasville",
          "Address1": "1133 Polk Ave, Nashville, TN 37210",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1b1273439kLELw9wSSiqD-_WhlAKGl18&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Boston",
      "Phone": "857-367-9469",
      "Address": [
        {
          "Location1": "Boston",
          "Address1": "855 Boylston St, Boston, MA 02116",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1yho9ZClpYYs5-XVsvPoakgClI1cGW00&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Austin",
      "Phone": "737-345-3189",
      "Address": [
        {
          "Location1": "Austin",
          "Address1": "501 W Powell Ln, Austin, TX 78753",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1ZFzBzklHnjRzKFG32H-Wn9TxmmpdSu8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Dallas",
      "Phone": "469-517-3782",
      "Address": [
        {
          "Location1": "Dallas",
          "Address1": "12035 Shiloh Rd, Dallas, TX 75228",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1Jq7olr9nIOOlBvrge9gBtQZ1gv38eSk&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Houston",
      "Phone": "346-483-3658",
      "Address": [
        {
          "Location1": "Houston",
          "Address1": "9255 Ley Rd, Houston, TX 77078",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1KYM_Tnx3zFBA9vvUnimOYgc3YHLlLBE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Connecticut",
      "Phone": "475-471-0156",
      "Address": [
        {
          "Location1": "Connecticut",
          "Address1": "725 Main St, Middletown, CT 06457",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1arTs8xd0v35vvinYSHJY5y2cU9EPi7g&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Chicago",
      "Phone": "872-278-5769",
      "Address": [
        {
          "Location1": "Chicago",
          "Address1": "1528 W Adams St,Chicago, IL 60607",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1Y2d_hgj3Z2rnaUFE90sd_RmsM456iVI&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Minneapolis",
      "Phone": "218-516-1702",
      "Address": [
        {
          "Location1": "Minneapolis",
          "Address1": "911 Nicollet Ave, Minneapolis, MN 55403",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=12fYx_1i1hARDMU9SIht0RVfutlIhFfM&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Providence",
      "Phone": "401-381-5150",
      "Address": [
        {
          "Location1": "Providence",
          "Address1": "1598 S County Trl, East Greenwich, RI 02818",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=19sCpvNHfs2nsnb7gXqYazMcVaDPtlMg&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Seattle",
      "Phone": "206-582-0317",
      "Address": [
        {
          "Location1": "Seattle",
          "Address1": "233 Westlake Ave N, Seattle, WA 98109",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1wpt9MtPAqDTtBJ8BGNjpjdKnSZ4IYxA&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Denver",
      "Phone": "866-646-7299",
      "Address": [
        {
          "Location1": "Denver",
          "Address1": "469 S Cherry St, Denver, CO 80246",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1-dZYn4IqFRsZTQoHlvmE7CAay5fosYQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Cleveland",
      "Phone": "216-677-1434",
      "Address": [
        {
          "Location1": "Cleveland",
          "Address1": "3100 E 45th St, Cleveland, OH 44127",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1yNBBqJvjaTYSULO-rnfEyRDfpLDl8_k&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Saint Louis",
      "Phone": "314-947-3122",
      "Address": [
        {
          "Location1": "Saint Louis",
          "Address1": "5901 Delmar Blvd, Saint Louis, MO 63112",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=15wIgRS6l1GFxtX5Ongf6ArLwOsAcML0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Atlanta",
      "Phone": "678-321-9614",
      "Address": [
        {
          "Location1": "Atlanta",
          "Address1": "1800 Jonesboro Rd SE, Atlanta, GA 30315",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1sIJWXQRLTPmw4YVHmgahsrJWSgd1VEM&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Charlotte",
      "Phone": "980-540-1087",
      "Address": [
        {
          "Location1": "Charlotte",
          "Address1": "6408 Bannington Rd, Charlotte, NC 28226",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1mhFU5wqgrPgYF_kqrRbwxfZT9SGr_BI&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Brooklyn",
      "Phone": "929-209-2876",
      "Address": [
        {
          "Location1": "Brooklyn",
          "Address1": "394 Hendrix St, Brooklyn, NY 11207",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=17OjSFSNGhqK3w-aOCSkHNgDzV8ybfjc&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Pittsburgh",
      "Phone": "412-723-8690",
      "Address": [
        {
          "Location1": "Pittsburgh",
          "Address1": "2429 E Carson St, Pittsburgh, PA 15203",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1BApI-jAERBFAmwEZFhwS147kwCJzpQo&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Knoxville",
      "Phone": "865-328-1893",
      "Address": [
        {
          "Location1": "Knoxville",
          "Address1": "1111 N Northshore Dr, Knoxville, TN 37919",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=18WO5IaIoTUxbT94-cyxay_cSjU7MG0I&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Phoenix",
      "Phone": "602-878-4419",
      "Address": [
        {
          "Location1": "Phoenix",
          "Address1": "1130 E Missouri Ave, Phoenix, AZ 85014",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1Msxuhd3bUNheRJDX7TytN94Bb4yvMdE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Columbus",
      "Phone": "614-662-4581",
      "Address": [
        {
          "Location1": "Columbus",
          "Address1": "751 Northwest Blvd, Columbus, OH 43212",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1KeRefWQyo4xvm94KiIaEAD-I1Tv-ipU&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "New Orleans",
      "Phone": "504-389-3025",
      "Address": [
        {
          "Location1": "New Orleans",
          "Address1": "8228 Oak St, New Orleans, LA 70118",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1rsEp_U1z2D1tFONzYAHz4kUdWNvRNSw&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Charleston",
      "Phone": "843-604-3567",
      "Address": [
        {
          "Location1": "Charleston",
          "Address1": "145 King St, Charleston, SC 29401",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1hw2L4CiXManJ_CI58HuHZ19PfTcRZQ8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Milwaukee",
      "Phone": "414-296-9011",
      "Address": [
        {
          "Location1": "Milwaukee",
          "Address1": "3073 S Chase Ave, Milwaukee, WI 53207",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1UhLnu-LJ2ZJs75rlYEslvH_k0rwDywQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Raleigh",
      "Phone": "919-444-8886",
      "Address": [
        {
          "Location1": "Raleigh",
          "Address1": "2020 Progress Ct, Raleigh, NC 27608",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1mU80sHsrx3sajxGM2kUjBAflBUJSYbU&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Birmingham",
      "Phone": "205-961-4777",
      "Address": [
        {
          "Location1": "Birmingham",
          "Address1": "324 Commons Dr, Birmingham, AL 35209",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1QR-lb-vzRwo6JqsxoALu0-j4RXq8Hcw&ehbc=2E312F&noprof=1",
    },

    {
      "Location": "Norfolk",
      "Phone": "757-379-8727",
      "Address": [
        {
          "Location1": "Norfolk",
          "Address1": "145 Dupree Ave, Norfolk, VA 23503",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1QR-lb-vzRwo6JqsxoALu0-j4RXq8Hcw&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Cincinnati",
      "Phone": "513-951-8106",
      "Address": [
        {
          "Location1": "Cincinnati",
          "Address1": "4850 Red Bank Rd, Cincinnati, OH 45227",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1007Wevk9UO7H_NF5el9BicLFmUCr-Ms&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Monsey",
      "Phone": "845-523-6778",
      "Address": [
        {
          "Location1": "Monsey",
          "Address1": "180 Franklin Tpke, Mahwah, NJ 07430",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1ruNj0ARlxKW5nXKHT2J5OGeA8b-03pU&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Portland",
      "Phone": "503-447-4741",
      "Address": [
        {
          "Location1": "Portland",
          "Address1": "1815 NE Broadway St, Portland, OR 97232",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1rNiB_ySheM5dd5ID9EUfOFilUjFg0UQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "West Palm Beach",
      "Phone": "561-277-0362",
      "Address": [
        {
          "Location1": "West Palm Beach",
          "Address1": "44 Cocoanut Row, Palm Beach, FL 33480",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1NJytl2FwaGzC4bZ4vu2TbXZrkrMj4GA&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Indianapolis",
      "Phone": "317-279-6826",
      "Address": [
        {
          "Location1": "Indianapolis",
          "Address1": "2346 S Lynhurst Dr, Indianapolis, IN 46241",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1BxTUns9WQX4vztBWS0UhLcOlK7kBHJU&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Louisville",
      "Phone": "502-717-1435",
      "Address": [
        {
          "Location1": "Louisville",
          "Address1": "105 Crescent Ave, Louisville, KY 40206",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1ifIMqzL5jRSg4NBMY_bdONq36UDzm_Q&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Salt Lake City",
      "Phone": "801-923-6117",
      "Address": [
        {
          "Location1": "Salt Lake City",
          "Address1": "2150 S 1300 E, Salt Lake City, UT 84106",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1R-XIKyV0rDl14--MUC00lCdUgK-Nr48&ehbc=2E312F&noprof=1",
    },
  ]

  // WebSitePages
  const [WebSitePages, setWebSitePages] = useState([
    // Resources
    {
      Name: "Home Page",
      Path: "/",
      category: "Resources"
    },
    {
      Name: "Apply Now",
      Path: "/apply",
      category: "Resources"
    },
    {
      Name: "Contact",
      Path: "/contact",
      category: "Resources"
    },
    {
      Name: "Blog",
      Path: "/blog",
      category: "Resources"
    },
    {
      Name: "Faq",
      Path: "/faq",
      category: "Resources"
    },
    // Aboout Us
    {
      Name: "Success Stories",
      Path: "/successstories",
      category: "About Us"
    },
    {
      Name: "Links",
      Path: "/links",
      category: "About Us"
    },

    // Servcies
    {
      Name: "Business Line of Credit",
      Path: "/business-line-of-credit",
      category: "Sulotion"
    },
    {
      Name: "Business Term Loan",
      Path: "/long-term-loan",
      category: "Sulotion"
    },
    {
      Name: "Small Business Loan",
      Path: "/sba-loan",
      category: "Sulotion"
    },
    {
      Name: "Same Day Funding",
      Path: "/same-day-funding",
      category: "Sulotion"
    },
    {
      Name: "Privacy Policy",
      Path: "/privacypolicy",
      category: "About"
    },
    {
      Name: "Terms Conditions",
      Path: "/termsconditions",
      category: "About"
    },
    {
      Name: "Site Map",
      Path: "/sitemap",
      category: "About"
    },
  ]);
  const navigateTo = (page) => {
    navigate('/' + page)
    setShowMenu(false)

  }

  return (
    <div className="App" style={false ? { "document.html.style.overflow": "hidden" } : null}>

      <Offline>
        <div className="OfflineApp">
          <h1><img src={unlock} alt="Chimney Sweep | Chimney Repair | Chimney Services | Chimney Inspection" /><span>Internet Connection Is Not Stable.</span>Your network seems to be disconnected. Please check your internet connection.</h1>
          <img onClick={() => window.location.reload()} className='OfflineAppClose' src={reload} alt="Chimney Sweep | Chimney Repair | Chimney Services | Chimney Inspection" />
        </div>
      </Offline>

      {/* Book an appointment */}
      {showPopUp ?
        <PopUp CitiePhone={CitiePhone} CitiesData={CitiesData} setShowPopUp={setShowPopUp} />
        : null}
      {/* Menu */}
      {showMenu ? <Menu CitiePhone={CitiePhone} WebSitePages={WebSitePages} navigateTo={navigateTo} setShowMenu={setShowMenu} /> : null}
      {/* Header */}
      {location.pathname == "/apply" || location.pathname == "/thankscontact" || location.pathname == "/thanks" || location.pathname.match("/portal/:*") ? null : <Header CitiePhone={CitiePhone} CitiesData={CitiesData} setShowPopUp={setShowPopUp} WebSitePages={WebSitePages} showMenu={showMenu} navigateTo={navigateTo} setShowMenu={setShowMenu} />}
      {/* Main */}
      <Main locationsMain={locationsMain} CitiePhone={CitiePhone} CitiesData={CitiesData} WebSitePages={WebSitePages} navigateTo={navigateTo} />
      {/* Footer */}
      {location.pathname.startsWith("/local") || location.pathname.startsWith("/book") || location.pathname == "/thanks" || location.pathname == "/thankscontact" || location.pathname.match("/portal/:*") ? null : <Footer CitiePhone={CitiePhone} WebSitePages={WebSitePages} navigateTo={navigateTo} />}

      {/* oNLINE */}

      {location.pathname == "/book" ? null : <a className='callButtonMainApp' href={`tel:${CitiePhone}`}> <img src={callbtn} alt="" />Click To Call!</a>}


    </div>
  );
}

export default App;
